<template>
  <!-- Figma D2 "Select Parts": one panel (header + count, search, list, Done). Qty / price / warranty are edited
       inline on the Summary card (D3), so Done just keeps the picked parts; Summary's Next checks prices. -->
  <div v-if="selectedItem" class="mobile:p-[4px] laptop:p-[20px] font-roboto">
    <FxModalHeader title="Select Parts" :dismiss="false" @close="closeButtonClicked()">
      <span class="ml-[8px] align-middle inline-flex items-center justify-center min-w-[24px] h-[18px] px-[6px] rounded-full bg-[#7695FF] text-white text-[12px]">
        {{ selectedItem.parts?.length || 0 }}
      </span>
    </FxModalHeader>
    <div class="mt-[15px]">
      <nest_modal_sidebar :booking-parts="bookingParts" :item="selectedItem" :index="index" />
    </div>
    <div class="flex justify-center gap-[10px] mt-[20px]">
      <!-- Figma mobile: only Done (the red ✕ closes) -->
      <button type="button" class="fxBtnSecondary [@media(max-width:1023px)]:!hidden" @click="closeButtonClicked()">
        Cancel
      </button>
      <button type="button" class="fxBtnPrimary disabled:bg-[#CCCCCC] disabled:border-[#CCCCCC]" :disabled="isAnyItemSlected" @click="callback('save')">
        Done
      </button>
    </div>
  </div>
</template>

<script>
import nest_modal_sidebar from "../../components/nest_components/nest_modal_sidebar.vue";
import FxModalHeader from "./FxModalHeader.vue";

export default {

  components: {
    nest_modal_sidebar,
    FxModalHeader,
  },
  // props: ["bookingParts", "item", "isOpen", "index"],

  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    item: Object,
    bookingParts: Array,
    index: Number,
  },

  data() {
    return {
      search: "",
      selectedItem: this.item ?? [],
      myModalEl: null,
      isItemSelected: false,
    };
  },

  computed: {
    isMobile() {
      return window.screen.width < 992 ? true : false;
    },

    isAnyItemSlected() {
      return (this.selectedItem.parts && this.selectedItem.parts.length > 0 )? false : true;
    }
    
  },

  watch: {
    isOpen: function () {
      this.setData();
      // this.selectedItem = []
      // this.selectedItem = JSON.parse(JSON.stringify(this.item));
    },

    // item: function () {
    //   this.isItemSelected = false
    //   this.selectedItem = []
    //   this.selectedItem = JSON.parse(JSON.stringify(this.item));
    // },
  },

  methods: {
    setData() {
      if (this.isOpen) {
        this.isItemSelected = false;
        this.selectedItem = [];
        this.selectedItem = JSON.parse(JSON.stringify(this.item));
      }
    },

    callbackSideBar() {
      this.isItemSelected = true;
    },

    checkVisibilitySidebar() {
      let res = true;
      if (this.isMobile) {
        res = !this.isItemSelected;
      }
      return res;
    },

    checkVisibility() {
      let res = true;
      if (this.isMobile) {
        res = this.isItemSelected;
      }
      return res;
    },

    callback(opt) {
      this.$emit("event", this.selectedItem, opt);
    },

    closeButtonClicked() {
      this.isItemSelected = false;
      this.$emit("event", this.selectedItem, "close");
    },
  },
};
</script>

<style></style>
